const DEFAULT_QUALITY = 82;

const withParams = (src, params) => {
  if (!src) return src;

  try {
    const url = new URL(src, window.location.origin);
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        url.searchParams.set(key, String(value));
      }
    });
    return url.href;
  } catch {
    return src;
  }
};

export const optimizedImageUrl = (src, width, quality = DEFAULT_QUALITY) => {
  if (!src || !width) return src;

  if (src.includes("images.unsplash.com")) {
    return withParams(src, {
      auto: "format",
      fit: "crop",
      w: width,
      q: quality,
    });
  }

  if (src.includes("/api/uploads/")) {
    return withParams(src, {
      w: width,
      q: quality,
    });
  }

  return src;
};

export const responsiveImageSrcSet = (src, widths, quality = DEFAULT_QUALITY) => {
  if (!src || !widths?.length) return undefined;

  const sources = widths
    .map((width) => `${optimizedImageUrl(src, width, quality)} ${width}w`)
    .filter(Boolean);

  return sources.length ? sources.join(", ") : undefined;
};
